import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PasswordRecoveryModel } from '@core/services/auth/auth.model';
import { AuthService } from '@core/services/auth/auth.service';
import { LocalStorageService } from '@core/services/local-storage/local-storage.service';

@Component({
  selector: 'Teranet-PasswordRecoveryQuestion',
  templateUrl: './password-recovery-question.component.html',
  styleUrls: ['./password-recovery-question.component.scss']
})
export class PasswordRecoveryQuestionComponent implements OnInit {
  emailAddress: string;
  errorMessage: string;
  isError: boolean;
  passwordRecoveryList: PasswordRecoveryModel[];

  constructor(
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.emailAddress = this.localStorageService.getItem('recoveryUser');

    if (!this.emailAddress) {
      this.router.navigate(['login']);
    }

    this.localStorageService.removeItem('recoveryUser');

    this.bindUserQuestions();
  }

  bindUserQuestions() {
    this.passwordRecoveryList = [];
    this.authService.getPasswordRecoveryQuestions(this.emailAddress).subscribe(value => {
      for (let i = 0; i < value.length; i++) {
        this.passwordRecoveryList.push({ passwordSecurityQuestionId: value[i].id, question: value[i].question, setId: value[i].setId, answer: null });
      }
    });
  }

  onCancel() {
    this.router.navigate(['login']);
  }

  onSubmit() {
    this.errorMessage = null;
    if (true) {
      this.authService.forgotPassword(this.emailAddress, this.passwordRecoveryList).subscribe(() => {
        this.isError = false;
        setTimeout(() => {
          this.router.navigateByUrl('/dashboard');
        }, 5000);
      },
        (err: HttpErrorResponse) => {
          if (String(err.error).startsWith("Your account has been locked.")) {
            this.router.navigateByUrl('/login?isAccountLocked=' + true);
          }
          else {
            this.isError = true;
            this.errorMessage = err.error;
          }
        });
    }
  }
}
